import { render, staticRenderFns } from "./CallMobile.vue?vue&type=template&id=55e5d4fa"
import script from "./CallMobile.vue?vue&type=script&lang=js"
export * from "./CallMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports